import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import './App.css';

import { AuthProvider } from './contexts/AuthContext';
import Info from './components/Info';
import News from './components/News';
import Promotions from './components/Promotions';
import LoyaltyCard from './components/LoyaltyCard';
import MyCoupons from './components/MyCoupons';
import Shipping from './components/Shipping';
import Help from './components/Help';
import Registration from './components/Registration';
import Login from './components/Login';
import Profile from './components/Profile';
import MenuDropdown from './components/MenuDropdown';
import Home from './components/Home';
import Stores from './components/Stores';
import PrivateRoute from './components/PrivateRoute';
import AuthCallback from './components/AuthCallback';

function AppWrapper() {
  return (
    <AuthProvider>
      <div className="App">
        <div className="logo-title-wrapper">
          <img src={require('./logo.PNG')} alt="logo" className="logo-small" />
          <img src={require('./BRUCALIFFO.png')} alt="Brucaliffo" className="title-image" />
        </div>
        <MenuDropdown />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/info" element={<Info />} />
          <Route path="/news" element={<News />} />
          <Route path="/promotions" element={<Promotions />} />
          <Route
            path="/loyaltycard"
            element={
              <PrivateRoute>
                <LoyaltyCard />
              </PrivateRoute>
            }
          />
          <Route
            path="/my-coupons"
            element={
              <PrivateRoute>
                <MyCoupons />
              </PrivateRoute>
            }
          />
          <Route
            path="/shipping"
            element={
              <PrivateRoute>
                <Shipping />
              </PrivateRoute>
            }
          />
          <Route path="/stores" element={<Stores />} />
          <Route path="/help" element={<Help />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/login" element={<Login />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <Profile />
              </PrivateRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
    </AuthProvider>
  );
}

export default function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}